/** Admin: add an attendant for one owner (owner-twin). */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { OwnerScopeProvider } from '../../../../../src/context/OwnerScopeContext';
import AddAttendantScreen from '../../../../owner/staff/add';

export default function AdminOwnerAddStaffScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();
  return (
    <OwnerScopeProvider ownerId={id}>
      <AddAttendantScreen />
    </OwnerScopeProvider>
  );
}
